<div [hidden]="consulta" class="evaluacion">
  <div class="row" style="height: 100%;">
      <div class="col-lg-12" style="padding: 0px;">
          <section class="widget" style="height: 100%;">
              <div class="row" *ngIf="entidadacuerdo.asignacionacuerdofirmaid != 0">
                <div class="col-12" style="margin-bottom: 1rem;" >
                  <span>Acuerdo anterior</span>
                  <div class="divisor8"></div>
                  <span>{{entidadacuerdo.fechatermino | date:"longDate"}} - {{entidadacuerdo.nombrejefe}} (jefe) y {{entidadacuerdo.nombresubordinado}}</span>
                  <div class="divisor8"></div>
                  <div class="scrollable-div" [innerHTML]="entidadacuerdo.textoacuerdo"></div>
                </div>
              </div>
              <div class="row" style="margin-top: 30px;">
                <div class="col-6" style="margin-bottom: 1rem; height: 40px;">
                  <span>Acuerdo actual - Captura a continuación los acuerdos, aspectos positivos y/o puntos a mejorar</span>
                </div>
                <div class="col-6" style="margin-bottom: 1rem; text-align: end;  height: 40px;" *ngIf="entidadacuerdoactual.firmado == false">
                  <button class="boton botonSM filledBlanco margenboton" [disabled]="accion.accionid == 2" (click)="guardarborrador()">Guardar</button>
                </div>
                <div class="col-12">
                  <div class="scrollable-div" [innerHTML]="entidadacuerdoactual.textoacuerdo" *ngIf=" accion.accionid == 2"></div>
                  <!--textareaCustom  [(ngModel)]="entidadacuerdoactual.textoacuerdo" [disabled]="entidadacuerdoactual.firmado || accion.accionid == 2"  data-toggle="tooltip" data-placement="top"></!--textareaCustom -->
                  <dx-html-editor height="250px" [(ngModel)]="entidadacuerdoactual.textoacuerdo" *ngIf=" accion.accionid == 1">
                    <dxo-toolbar [multiline]="true">
                      <dxi-item name="undo"></dxi-item>
                      <dxi-item name="redo"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item
                        name="size"
                        [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"
                        [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
                      ></dxi-item>
                      <dxi-item
                        name="font"
                        [acceptedValues]="[
                          'Arial',
                          'Courier New',
                          'Georgia',
                          'Impact',
                          'Lucida Console',
                          'Tahoma',
                          'Times New Roman',
                          'Verdana'
                        ]"
                        [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
                      ></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="bold"></dxi-item>
                      <dxi-item name="italic"></dxi-item>
                      <dxi-item name="strike"></dxi-item>
                      <dxi-item name="underline"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="alignLeft"></dxi-item>
                      <dxi-item name="alignCenter"></dxi-item>
                      <dxi-item name="alignRight"></dxi-item>
                      <dxi-item name="alignJustify"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="orderedList"></dxi-item>
                      <dxi-item name="bulletList"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item
                        name="header"
                        [acceptedValues]="[false, 1, 2, 3, 4, 5]"
                        [options]="{ inputAttr: { 'aria-label': 'Header' } }"
                      ></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="color"></dxi-item>
                      <dxi-item name="background"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="link"></dxi-item>
                      <dxi-item name="image"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="clear"></dxi-item>
                      <dxi-item name="codeBlock"></dxi-item>
                      <dxi-item name="blockquote"></dxi-item>
                      <dxi-item name="separator"></dxi-item>
                      <dxi-item name="insertTable"></dxi-item>
                      <dxi-item name="deleteTable"></dxi-item>
                      <dxi-item name="insertRowAbove"></dxi-item>
                      <dxi-item name="insertRowBelow"></dxi-item>
                      <dxi-item name="deleteRow"></dxi-item>
                      <dxi-item name="insertColumnLeft"></dxi-item>
                      <dxi-item name="insertColumnRight"></dxi-item>
                      <dxi-item name="deleteColumn"></dxi-item>
                    </dxo-toolbar>
                    <dxo-media-resizing [enabled]="true"> </dxo-media-resizing>
                  </dx-html-editor>
                </div>
                <br>
                <div></div>
                <div class="col-12" style="margin-top: 30px;">
                  <div class="row">
                    <div class="col-6">
                      <div style="text-align: center;">
                        <span>{{entidad.nombrejefe}}</span>
                        <div class="divisor8"></div>
                        <span>{{entidad.puestoje}}</span>
                        <div class="divisor8"></div>
                        <button class="boton botonSM filledBlanco margenboton" *ngIf="!entidadacuerdoactual.firmajefe" [disabled]="accion.accionid == 2" (click)="formulario(1)">Firmar</button>
                        <div *ngIf="entidadacuerdoactual.firmajefe">
                          <span>firmado</span>
                          <div class="divisor8"></div>
                          <span>{{entidadacuerdoactual.fechafirmajefe | date:"medium"}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div style="text-align: center;">
                        <span>{{entidad.nombresubordinado}}</span>
                        <div class="divisor8"></div>
                        <span>{{entidad.puestosub}}</span>
                        <div class="divisor8"></div>
                        <button class="boton botonSM filledBlanco margenboton" *ngIf="!entidadacuerdoactual.firmasubordinado" [disabled]="accion.accionid == 2" (click)="formulario(2)">Firmar</button>
                        <div *ngIf="entidadacuerdoactual.firmasubordinado">
                          <span>firmado</span>
                          <div class="divisor8"></div>
                          <span>{{entidadacuerdoactual.fechafirmasubordinado | date:"medium"}}</span>
                        </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
          </section>
      </div>
  </div>
</div>

<ng-container *ngIf="abierto">
  <div class="backdrop"></div>
  <div class="modalPanelAdminlogin animated {{animacion}}">

      <div class="contenido">
         <!--  Título -->
          <div class="encabezadoModal">
              <div class="modalTituloSimple">
                  {{('Firma de acuerdo')}}
              </div>
          </div>
          <div class="modalContenido">
             <!--  datos -->
              <div>
                  <h5>Para firmar el acuerdo captura tu usuario y contraseña</h5>
                  <div class="divisor8"></div>
                  <div class="">
                     <!--  Datos generales -->
                     <div style="text-align: center;">
                      <div class="floatLabel inputRedondeado">

                        <input placeholder="{{'Login.Cuenta' | translate }}" autofocus id="lcuenta" type="text" class="form-control inputLoginModal"
                               [(ngModel)]="login.Cuenta" name="cuenta" #cuenta="ngModel" required
                               [ngClass]="{'is-filled':cuenta.value }">

                               <button *ngIf="cuenta.value" class="btnTimes" (click)="login.Cuenta = '';" onclick="Focus('lcuenta')" tabindex="-1">
                            <span class="fa fa-times"></span>
                        </button>

                        <span class="textoError" [hidden]="cuenta.valid || (!cuenta.touched && !login.errorActivo)">
                            {{'Login.ErrorCuenta' | translate}}
                        </span>

                      </div>
                      <div class="divisor8"></div>
                      <div class="floatLabellogin inputRedondeado">
                        <input placeholder="{{'Login.Password' | translate}}" type="{{verPassword ? 'text' : 'password'}}" id="lpassword" class="form-control inputPassword" [(ngModel)]="login.Password" name="password"
                               #password="ngModel" required [ngClass]="{'is-filled':password.value }">


                        <button class="btnVerPassword" (click)="CambiarVerPassword()">
                          <span class="fa fa-eye" *ngIf="verPassword"></span>
                          <span class="fa fa-eye-slash" *ngIf="!verPassword"></span>
                      </button>

                        <span class="textoError" [hidden]="password.valid || (!password.touched && !errorActivo)">
                            {{'Login.ErrorPassword' | translate}}
                        </span>

                    </div>
                    <div class="divisor8"></div>
                     </div>
                  </div>
              </div>

          </div>

         <!--  footer -->
          <div class="modalFooter">
                 <!--  editar -->
                  <div class="row">
                      <div class="col-6">
                        <button class="boton botonSM filledBlanco botonfooter" (click)="CerrarModalInterno()">
                          {{'Cancelar' | translate}}
                      </button>
                      </div>
                      <div class="col-6">
                        <button class="boton botonSM filled" (click)="GuardarFirma()">
                            {{'Confirmar' | translate}}
                        </button>
                      </div>
                  </div>
          </div>
      </div>
  </div>
</ng-container>
